import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm, useWatch } from "react-hook-form";
import { LoadingButton } from "@rentablo/components";
import { RHFTextField } from "@rentablo/components";
import { preventNonNumericInput } from "@helpers";

interface Props {
  onDisable: (code: number) => void;
  isLoading?: boolean;
}

interface FormFields {
  code: number;
}

export const DisableView = ({ onDisable, isLoading }: Props) => {
  const { t } = useTranslation();

  const { control } = useForm<FormFields>({
    defaultValues: { code: undefined },
  });

  const code = useWatch({ control, name: "code" });

  const handleClick = () => {
    if (code) {
      onDisable(code);
    }
  };

  return (
    <>
      <Typography variant="body3" color="textSecondary" mb={7}>
        {t("settings.twoFA.disable.description")}
      </Typography>
      <RHFTextField
        label={t("settings.twoFA.codeLabel")}
        name="code"
        type="number"
        fullWidth
        control={control}
        sx={{ mb: 7 }}
        disabled={isLoading}
        testId="2fa-code-field"
        onBeforeInput={preventNonNumericInput}
      />
      <LoadingButton
        data-testid="2fa-disable-confirm-button"
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleClick}
        disabled={!code}
        isFetching={isLoading}
      >
        {t("settings.twoFA.disable.disableButton")}
      </LoadingButton>
    </>
  );
};
